
export default [
  {
    "slug": "/resume/freelancer-2002-2004",
    "share": "/logos/spyder.png",
    "resume": {
      "logo": "spyder.png",
      "category": "Career",
      "company": "Spyder Designs",
      "jobTitle": "Freelance Web Developer",
      "type": "Adhoc Portfolios",
      "arrangement": "Remote",
      "location": "Springs, South Africa",
      "start": "2002-01-01",
      "end": "2004-12-31",
      "os": "windows",
      "tech": [
        "Web Development",
        "Object-Oriented Programming",
        "JSP",
        "Java",
        "HTML",
        "CSS",
        "JavaScript",
        "Photoshop"
      ],
      "summary": "Worked as a freelance web developer together with local businesses to create and maintain their online presence."
    },
    "content": "I started my career as a freelance web developer in 2002, working with local businesses to create and maintain their online presence.\nDuring this time, I honed my skills in web design and development, learning to work independently and manage client relationships effectively.\n\n## Skills\n\n`tags: Web Development, JSP, Java, HTML, CSS, JavaScript, Photoshop, Macromedia Dreamweaver`\n\n## Projects\n\n- Dr Johan Jurgens website\n- Dr Johan Jurgens prospectus (Printed material)\n- Dr Johan Jurgens newspaper (Printed & digital)\n- Cyber Village (School IT College)\n- Springs Chamber of Commerce website\n- Springs Advertiser website (local newspaper)\n- Stable Inn website (local restaurant, pub, and accommodation guest house)\n- Elco Steel website (local steel company)",
    "_meta": {
      "filePath": "2002-freelancer.md",
      "fileName": "2002-freelancer.md",
      "directory": ".",
      "extension": "md",
      "path": "2002-freelancer"
    },
    "date": new Date("2002-01-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/education-johan-jurgens",
    "share": "/logos/jj.png",
    "resume": {
      "logo": "jj.png",
      "category": "Education",
      "company": "Dr Johan Jurgens High School",
      "jobTitle": "Matric",
      "type": "Student",
      "location": "Springs, South Africa",
      "start": "1999-01-01",
      "end": "2003-12-31",
      "tech": [
        "Mathematics",
        "Physical Science",
        "Economics",
        "Computer Science",
        "English",
        "Afrikaans"
      ],
      "summary": "I passed on Higher Grade with University exception, represented the student council twice, was school newspaper Layout Editor and then Editor in Chief and Webmaster of the school's IT college."
    },
    "content": "## Letter from the Principal\n\nI, the undersigned, hereby testify that Clarice Billowes was a registered pupil of the above school from January 1999 until December 2003.\n\nShe is currently writing the Gauteng Senior Certificate Examination in the following subjects:\n\n- English First Language HG\n- Afrikaans Second Language HG\n- Mathematics HG\n- Physical Science HG\n- Economics HG\n- Computer Science HG\n\nClarice is a conscientious and determined young lady who strives to do her best at all times.\nShe is helpful, lively, sweet-natured and popular among her peers.\nClarice was elected for the Student Representative Council for 2002 and 2003.\nHer duties were carried out enthusiastically.\n\nClarice has excelled academically throughout her school career.\nShe has a special talent for the written word and wrote three poems that were published.\nOne of these poems was also published in America and the United Kingdom.\nClarice was editor of the school newspaper for 2003 and layout editor for 2001 and 2002.\nHer strong sense of duty is reflected in her good school attendance record.\n\nHer computer Studies was put to good use in web-designing.\nShe received a special award for her Stable Inn website, designed in 2002.\nThe Golden Web award was given to her in 2002 and 2003.\nIn 2001, she was the webmaster of the Johan Jurgens - Cybervillage.\n\nWe believe Clarice will always strive to do excellent work and that she will be an asset for any position she applies for.\n\nHPD van Wyk\\\nPrincipal of Dr Johan Jurgens High School\n\n## Achievements\n\n- Honorary Colours - School Newspaper - 2003\n- Student Representative Council - 2002 and 2003\n- Golden Web award - 2002 and 2003\n- Editor of school newspaper - 2003\n- Layout editor - 2001 and 2002\n- Webmaster - 2001\n- Published poetry",
    "_meta": {
      "filePath": "2003-eductation-johan-jurgens.md",
      "fileName": "2003-eductation-johan-jurgens.md",
      "directory": ".",
      "extension": "md",
      "path": "2003-eductation-johan-jurgens"
    },
    "date": new Date("1999-01-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/cti",
    "share": "/logos/cti.png",
    "resume": {
      "logo": "cti.png",
      "category": "Career",
      "company": "Computer Training Institute",
      "jobTitle": "Junior Instructor",
      "type": "Full-Time",
      "arrangement": "Onsite",
      "location": "Bedfordview, South Africa",
      "start": "2005-01-01",
      "end": "2005-12-31",
      "os": "windows",
      "tech": [
        "Web Development",
        "Object-Oriented Programming",
        "C#",
        "VB.NET",
        "Java",
        "SQL",
        "HTML",
        "CSS",
        "JavaScript"
      ],
      "summary": "At the Computer Training Institute, backed by the University of Cambridge and later acquired by Pearson, I developed learning materials, facilitated interactive workshops, and provided personalized mentorship to students. My efforts in delivering relevant course content and offering dedicated support consistently fostered collaboration, skill development, and a notably low failure rate."
    },
    "content": "The CTI Education Group (CTI) was a registered, private higher education institution in South Africa.\nFull-time and part-time students could study within the fields of Information Technology,\nPsychology & Counselling, Creative Arts & Graphic Design, Commerce and Law on campuses spread throughout South Africa.\nLater acquired by Pearson.\n\n- Developed and delivered pre-test materials, ensuring students prepare, comprehend and align with the curriculum.\n- Facilitated engaging and interactive workshops, fostering a collaborative learning environment for students.\n- Evaluated student projects and provided constructive feedback, promoting skill development and knowledge retention.\n- Maintained a consistently low student failure rate by providing personalized support and guidance, demonstrating a commitment to student success.\n- Mentored and supported students through self-paced study programs, fostering independent learning and problem-solving skills.\n- Assisted in the development and maintenance of course materials, ensuring accuracy and relevance to industry standards.\n\n## Skills\n\n`tags: Web Development, Object-Oriented Programming, C#, VB.NET, Java, SQL, HTML, CSS, JavaScript`\n\n`tags: Communication, Problem Solving, Critical Thinking, Adaptability, Time Management, Teamwork`\n\n![Door](https://fastly.4sqi.net/img/general/600x600/19998773_GyBuKJHNbTe6012z5_UYmHmnAJQ1maTQyPwEMh5f08A.jpg \"Door\")",
    "_meta": {
      "filePath": "2004-cti.md",
      "fileName": "2004-cti.md",
      "directory": ".",
      "extension": "md",
      "path": "2004-cti"
    },
    "date": new Date("2005-01-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/education-cti-computer-science",
    "share": "/logos/cti.png",
    "resume": {
      "logo": "cti.png",
      "category": "Education",
      "company": "Computer Training Institute",
      "jobTitle": "Information Systems Software Development",
      "type": "Full-Time",
      "arrangement": "Onsite",
      "location": "Bedfordview, South Africa",
      "start": "2004-01-01",
      "end": "2004-12-31",
      "tech": [
        "C#",
        "VB.NET",
        "SQL"
      ],
      "summary": "Computer Science - Internet Development (2004) - 86% (Bursary Awarded)"
    },
    "content": "Completed a Diploma in Computer Science: Internet Development with an 86% average, gaining a comprehensive foundation in full-stack web development principles. This program equipped me with the skills to design, develop, and deploy web applications, and provided a strong understanding of software development methodologies\n\n## Skills\n\n`tags: Computing Concepts, End User, Using Linux, Processing and Logic Concepts, Software Engineering, Program Design, Relational Database Modelling, SQL Server 2000, DHTML, Java, XML, Delivery Web Services, Perl, C#, Hardware Essentials, VB.NET`",
    "_meta": {
      "filePath": "2004-eductation-cti.md",
      "fileName": "2004-eductation-cti.md",
      "directory": ".",
      "extension": "md",
      "path": "2004-eductation-cti"
    },
    "date": new Date("2004-01-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/education-cti-information-systems",
    "share": "/logos/cti.png",
    "resume": {
      "logo": "cti.png",
      "category": "Education",
      "company": "Computer Training Institute",
      "jobTitle": "Computer Science - Internet Development",
      "type": "Full-Time",
      "arrangement": "Onsite",
      "location": "Bedfordview, South Africa",
      "start": "2005-01-01",
      "end": "2005-12-31",
      "tech": [
        "C#",
        "VB.NET",
        "SQL"
      ],
      "summary": "Information Systems Software Development (2004) - 83%"
    },
    "content": "Completed my initial diploma, earning a bursary for further study. Developed a strong foundation in software development principles, including software engineering, program design, and relational database modeling (SQL Server 2000). Gained practical experience with Java, XML, and web technologies such as DHTML and Perl, enabling the creation of dynamic web applications. Proficient in Linux and fundamental computing concepts.\n\n## Skills\n\n`tags: Computing Concepts, End User, Using Linux, Processing and Logic Concepts, Software Engineering, Program Design, Relational Database Modelling, SQL Server 2000, DHTML, Java, XML, Delivery Web Services, Perl, C#, Hardware Essentials, VB.NET`",
    "_meta": {
      "filePath": "2005-education-cti.md",
      "fileName": "2005-education-cti.md",
      "directory": ".",
      "extension": "md",
      "path": "2005-education-cti"
    },
    "date": new Date("2005-01-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/microsoft-event-registration",
    "share": "/logos/tech-ed.webp",
    "resume": {
      "logo": "tech-ed.png",
      "category": "Project",
      "company": "IT Event Management",
      "jobTitle": "Microsoft Event Registrations",
      "type": "> 1500 delegates",
      "arrangement": "Digital & Onsite Registration",
      "location": "South Africa & Dubai",
      "start": "2006-09-01",
      "end": "2012-03-01",
      "os": "windows",
      "tech": [
        "Web Development",
        "VB.NET",
        "SQL",
        "Credit Card Gateways",
        "HTML",
        "CSS",
        "JavaScript",
        "Photoshop"
      ],
      "summary": "Microsoft needed a custom branded platform to manage event attendees across multiple large-scale conferences in South Africa and Dubai. I led the UX design and full-stack development, integrating secure payment gateways, ensuring 99.9% uptime, and delivering a seamless experience for thousands of attendees."
    },
    "content": "- Delivered a custom branded attendee management platform for Microsoft events such as Tech-Ed, Partner Summit, DevDays, and TechDays across South Africa and Dubai, enabling large-scale event operations.\n- Led UX design, creating a consistent and professional experience that aligned with Microsoft’s global brand across multiple events.\n- Architected and developed robust applications that scaled to support thousands of users, ensuring reliability and efficiency throughout each project lifecycle.\n- Integrated secure payment gateways (Nedbank iVeri, Mashreq), facilitating smooth and compliant online transactions.\n- Maintained 99.9% uptime and provided on-site technical support, resolving critical issues quickly and ensuring a seamless experience for over 1,000 attendees per event.\n\n`tags: SQL, VB.NET, HTML, CSS, JavaScript, jQuery, Bootstrap, AJAX`\n\n`tags: Event Management, UX Design, Full-Stack Development, Payment Gateway Integration, Photoshop, High Availability, Onsite Support`",
    "_meta": {
      "filePath": "2006-events.md",
      "fileName": "2006-events.md",
      "directory": ".",
      "extension": "md",
      "path": "2006-events"
    },
    "date": new Date("2006-09-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/globres",
    "share": "/logos/globres.png",
    "resume": {
      "logo": "globres.png",
      "category": "Career",
      "company": "Globres",
      "jobTitle": "Junior Web Developer",
      "type": "Full-Time",
      "arrangement": "Onsite",
      "location": "Sandton, South Africa",
      "start": "2006-01-01",
      "end": "2006-08-31",
      "os": "windows",
      "tech": [
        "Web Development",
        "Object-Oriented Programming",
        "C#",
        "SQL",
        "HTML",
        "CSS",
        "JavaScript"
      ],
      "summary": "Developed and maintained the Global Hotel Reservation web application, a core tool for managing hotel bookings, while designing and implementing new features driven by user feedback to boost efficiency and satisfaction. Provided ongoing support and troubleshooting, ensuring smooth operations and minimal disruption for the business."
    },
    "content": "Globres is a Swiss-based hospitality technology company providing hotel e-distribution and revenue-management solutions.\n\n- Developed and maintained the Global Hotel Reservation web application, a critical internal tool used to manage hotel bookings.\n- Designed and implemented new features based on user feedback, resulting in increased efficiency and user satisfaction.\n- Provided ongoing support and troubleshooting for the application, minimizing disruption to internal operations.\n\n## Skills\n\n`tags: C#, SQL, HTML, CSS, JavaScript, Visual Source Safe, Object-Oriented Programming, Visual Studio`\n\n`tags: Communication, Problem Solving, Critical Thinking, Adaptability, Time Management, Team Work`",
    "_meta": {
      "filePath": "2006-globres.md",
      "fileName": "2006-globres.md",
      "directory": ".",
      "extension": "md",
      "path": "2006-globres"
    },
    "date": new Date("2006-01-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/it-em",
    "share": "/logos/it-em.png",
    "resume": {
      "logo": "it-em.png",
      "category": "Career",
      "company": "IT Event Management",
      "jobTitle": "Lead Web Developer",
      "type": "Full-Time",
      "arrangement": "Onsite",
      "location": "Johannesburg North, South Africa",
      "start": "2006-09-01",
      "end": "2012-04-30",
      "os": "windows",
      "tech": [
        "Web Development",
        "Object-Oriented Programming",
        "VB.NET",
        "SQL",
        "Credit Card Gateways",
        "HTML",
        "CSS",
        "JavaScript"
      ],
      "summary": "Developed and delivered custom event registration websites for major events like Microsoft Tech-Ed and Partner Summits, implementing features such as secure payments, RFID integration, and reporting systems to ensure seamless user experiences. By collaborating closely with clients and managing multiple projects under tight deadlines, consistently exceeded expectations while providing full ownership and on-site support."
    },
    "content": "IT Event Management is a technology-driven event services provider offering onsite registration and RSVP websites.\n\n- Developed custom event registration websites with a portfolio of Microsoft Tech-Ed (South Africa and Dubai) & Partner Summit and Microsoft Bootcamps.\n- Collaborated directly with clients to source and understand their needs and translate them into effective technical solutions.\n- Implemented key features such as secure payment gateways, event agendas, speaker rating scores, RFID integration for efficient on-site registration, and comprehensive reporting systems.\n- Successfully managed multiple projects simultaneously under strict and tight deadlines I consistently exceeded client expectations.\n- Contributed to the success of major events by ensuring seamless registration processes and a positive user experience.\n- Provided on-site support with delegate and speaker queries and took full ownership and accountability for the projects.\n\n## Projects\n\n- **Microsoft Tech-Ed Middle East**: Designed and developed the event websites, providing on-site support in Dubai. Learned a valuable lesson in optimizing performance for slow connections and the importance of using UTC time.\n- **Microsoft Tech-Ed South Africa**: Created and managed the event registration platforms.\n- **Microsoft Partner Summit**: Developed the registration and management systems for the summit.\n- **Microsoft Bootcamps**: Built and maintained registration websites for various bootcamp events such as Microsoft Tech-Days, Microsoft Dev Days etc.\n\n### Features\n\n- Fully customized event registration websites.\n- Secure payment gateways integrated with iVeri and Masreq.\n- Dynamic event agendas and speaker rating systems.\n- RFID integration for efficient on-site registration.\n- Comprehensive reporting systems for event management.\n- On-site support during events to handle delegate and speaker queries.\n- Bulk SMS and email communication systems for event updates and notifications.\n- Responsive design using Bootstrap and jQuery for optimal user experience across devices.",
    "_meta": {
      "filePath": "2006-it-em.md",
      "fileName": "2006-it-em.md",
      "directory": ".",
      "extension": "md",
      "path": "2006-it-em"
    },
    "date": new Date("2006-09-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/blog",
    "share": "/logos/curious-programmer.jpg",
    "resume": {
      "logo": "curious-programmer.jpg",
      "category": "Project",
      "company": "Personal Project",
      "jobTitle": "Curious Programmer Blog",
      "type": "> 500 users",
      "arrangement": "Pet Project",
      "location": "Blog",
      "start": "2008-01-01",
      "tech": [
        "Web Development",
        "HTML",
        "CSS",
        "JavaScript",
        "Gatsby",
        "Tailwind CSS",
        "Firebase",
        "Netlify"
      ],
      "summary": "A long-running blog built with Gatsby.js and TailwindCSS, deployed on Netlify and Firebase, documenting my journey as a software developer while exploring new technologies and sharing lessons learned."
    },
    "content": "A long-running blog built with Gatsby.js and TailwindCSS, deployed on Netlify and Firebase, documenting my journey as a software developer while exploring new technologies and sharing lessons learned. Demonstrates strong front-end engineering, serverless deployment expertise, and the ability to engage audiences through technical writing, SEO, and community interaction.\n\n- Showcased modern JavaScript and front-end expertise through a production-ready blog platform.\n\n- Applied serverless deployment practices (Netlify, Firebase) to ensure scalability and reliability.\n\n- Produced technical content optimized for SEO, growing reach and discoverability.\n\n- Built a sustained track record of knowledge sharing and community engagement, strengthening personal brand and credibility.\n\n`tags: Web Development, HTML, CSS, JavaScript, Gatsby, Tailwind CSS, Firebase, Netlify, Node.js, Creative Writing`",
    "_meta": {
      "filePath": "2008-blog.md",
      "fileName": "2008-blog.md",
      "directory": ".",
      "extension": "md",
      "path": "2008-blog"
    },
    "date": new Date("2008-01-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/bootcamp-registration",
    "share": "/logos/microsoft.jpg",
    "resume": {
      "logo": "microsoft.jpg",
      "category": "Project",
      "company": "IT Event Management",
      "jobTitle": "Bootcamp Event Registration Portal",
      "type": "> 1000 delegates",
      "arrangement": "Digital & Onsite Registration",
      "location": "South Africa & Dubai",
      "start": "2012-01-01",
      "end": "2012-04-30",
      "os": "windows",
      "tech": [
        "Web Development",
        "VB.NET",
        "SQL",
        "Credit Card Gateways",
        "HTML",
        "CSS",
        "JavaScript",
        "Photoshop"
      ],
      "summary": "Hand-rolling each project took a lot of development effort. Streamlined the process by introducing a portal to build fully customizable, multi-tenancy Bootcamps for event registrations geared for Microsoft but generic enough to be used by other vendors."
    },
    "content": "Hand-rolling each project took a lot of development effort. Streamlined the process by introducing a portal to build fully customizable, multi-tenancy Bootcamps for event registrations geared for Microsoft but generic enough to be used by other vendors.\n\n- Cut development effort by 70% per project by architecting and implementing a multi-tenant Bootcamp registration portal, replacing hand-rolled event builds.\n\n- Boosted partner visibility and attendee engagement through a branded Bootcamp listing page, enabling companies to showcase offerings and attract sign-ups.\n\n- Improved attendee experience by engineering a secure, streamlined registration process that reduced friction and administrative overhead.\n\n- Increased operational efficiency with a comprehensive management portal, leading to a 20% drop in support tickets and faster response times.\n\n`tags: SQL, VB.NET, HTML, CSS, JavaScript, jQuery, Bootstrap, AJAX`\n\n`tags: Event Management, UX Design, Full-Stack Development, Payment Gateway Integration, Photoshop, High Availability, Onsite Support`",
    "_meta": {
      "filePath": "2012-bootcamp-portal.md",
      "fileName": "2012-bootcamp-portal.md",
      "directory": ".",
      "extension": "md",
      "path": "2012-bootcamp-portal"
    },
    "date": new Date("2012-01-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/remata",
    "share": "/logos/remata.png",
    "resume": {
      "logo": "remata.png",
      "category": "Career",
      "company": "Remata Cross Media Solutions",
      "jobTitle": "Senior Software Developer",
      "type": "Full-Time",
      "arrangement": "Hybrid",
      "location": "Midrand, South Africa",
      "start": "2012-07-01",
      "end": "2014-03-31",
      "os": "windows",
      "tech": [
        "Web Development",
        "Object-Oriented Programming",
        "C#",
        "SQL",
        "jQuery",
        "Bootstrap",
        "XMPie"
      ],
      "summary": "Collaborated with stakeholders to translate complex printing requirements into automated software solutions, developing features with C#, SQL, and Visual Studio that streamlined processes and boosted efficiency. By integrating with XMPie for on-demand variable data printing, enhanced personalization for clients and reduced turnaround times."
    },
    "content": "Remata offers digital and litho printing, point-of-sale materials, packaging, variable-data and cross-channel marketing, design/layout services and a unique Web-2-print online storefront.\n\n- Collaborated with stakeholders to understand printing process requirements and translate them into automated software solutions.\n- Developed and implemented features for printing processes using C#, SQL, and Visual Studio, significantly reducing manual intervention and improving efficiency.\n- Integrated software solutions with XMPie to enable on-demand variable data printing, enhancing personalization capabilities for clients and leading to faster turnaround times.\n- Applied technical expertise to existing solutions.\n\n## Skills\n\n`tags:C#, SQL, jQuery, Bootstrap, Object-Oriented Programming, XMPie Integration, iVeri Nedbank Payment Integration, Windows, Visual Studio`\n\n`tags: Communication, Problem Solving, Critical Thinking, Adaptability, Time Management`\n\n## Projects\n\n- **Nashua Mobile**: Built a cross media solution for Nashua Mobile agents to send personalized prospectus brochures to print for their prospective business clients.\n- **Platinum Life**: Built an automation service which imports data, provides it to a personalization component and sends it for print. Jobs were handled concurrently.\n- **Photo2Print**: Integrate with the Photo2Print services.",
    "_meta": {
      "filePath": "2012-remata.md",
      "fileName": "2012-remata.md",
      "directory": ".",
      "extension": "md",
      "path": "2012-remata"
    },
    "date": new Date("2012-07-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/testimonial-from-amory-somers-vine",
    "share": "/logos/speech-bubble.webp",
    "resume": {
      "name": "Amory Somers Vine",
      "description": "My client",
      "logo": "amory-somers-vine.jpeg",
      "category": "Testimonial",
      "start": "2012-04-18",
      "summary": "Amory describes me as a fantastic team asset, emphasizing her remarkable commitment to delivery and attention to detail."
    },
    "content": "Clarice is a fantastic asset to have on your team.\nHer commitment to delivery and her attention to detail are remarkable!",
    "_meta": {
      "filePath": "2012-testimonial-amory-somers-vine.md",
      "fileName": "2012-testimonial-amory-somers-vine.md",
      "directory": ".",
      "extension": "md",
      "path": "2012-testimonial-amory-somers-vine"
    },
    "date": new Date("2012-04-18T00:00:00.000Z")
  },
  {
    "slug": "/resume/testimonial-from-david-sieff",
    "share": "/logos/speech-bubble.webp",
    "resume": {
      "name": "David Sieff",
      "description": "My client",
      "logo": "david-sieff.jpeg",
      "category": "Testimonial",
      "start": "2012-05-23",
      "summary": "David praises me for my dedication and hard work in developing a critical transactional web portal, highlighting my flexibility in accommodating changes throughout the project milestones, and commending my excellent attention to detail and creativity in overcoming challenges with viable alternatives."
    },
    "content": "I had the pleasure of working with Clarice on a critical transactional web portal, which she helped develop and gave us the flexibility to make changes as we stepped through the various milestones until completion. She is dedicated, hard working and has very good attention to detail along with creativity to work around challenges and provide a viable alternative.",
    "_meta": {
      "filePath": "2012-testimonial-david-sieff.md",
      "fileName": "2012-testimonial-david-sieff.md",
      "directory": ".",
      "extension": "md",
      "path": "2012-testimonial-david-sieff"
    },
    "date": new Date("2012-05-23T00:00:00.000Z")
  },
  {
    "slug": "/resume/multichoice",
    "share": "/logos/multichoice.png",
    "resume": {
      "logo": "multichoice.png",
      "category": "Career",
      "company": "MultiChoice Group",
      "jobTitle": "Senior Software Developer",
      "type": "Full-time",
      "arrangement": "Onsite",
      "location": "Randburg, South Africa",
      "start": "2014-04-01",
      "end": "2018-06-30",
      "os": "windows",
      "tech": [
        "Web Development",
        "Object-Oriented Programming",
        "C#",
        "SQL",
        "DevOps",
        "Agile",
        "Microservices",
        "Caching",
        "SonarQube"
      ],
      "summary": "Contributed to high-visibility media and entertainment platforms including Idols, Big Brother, AMVCA, Survivor, and later DStv Now, providing online streaming to millions of households across Africa. Architected, engineered, and supported complex distributed web solutions within Agile Scrum teams, with a strong emphasis on code quality, test automation, CI/CD, and DevOps practices. Beyond technical delivery, mentored junior developers, ensured platform stability during team transitions, and collaborated closely with stakeholders to meet business needs while resolving critical issues and supporting customer queries."
    },
    "content": "MultiChoice Group is a South African-based media & entertainment company that operates key subscription video platforms serving over 20 million households across sub-Saharan Africa.\n\nJoined the MultiChoice Group in the DStv Digital Media division as an outsourced professional through Britehouse (formerly 3Fifteen) and transitioned to MultiChoice directly in 2016.\n\nOriginally forming part of the Original Productions team working on production based voting solutions such as Idols, Big Brother, Channel O Music Video Awards, Africa Magic Viewers; Choice Awards (AMVCA) and Survivor, thereafter, DStv Now which was launched a service offering online streaming for linear and video on demand to DStv customers. Offered support for numerous services such as SuperSport, BoxOffice, Recommendations Services, and others.\n\n- Key player in adaptable, cross-functional Agile Scrum teams.\n- Architected, engineered, maintained and supported high-visibility, complex, distributed web solutions and platforms.\n- Leveraged strong communication and collaboration to maintain product stability during periods of significant team turnover.\n- Resolved critical issues, and ensured the continued operation of these key platforms.\n- Strong focus on code quality, test automation, and continuous integration and delivery (CI/CD) using Jenkins and Git.\n- Mentored junior developers, fostering a culture of continuous learning and improvement within the team.\n- Participated in code reviews, ensuring adherence to best practices and coding standards.\n- Engaged in sprint planning, retrospectives, and daily stand-ups to ensure effective team collaboration and project progress.\n- Worked closely with product owners and stakeholders to understand requirements and deliver solutions that meet business needs.\n- Implemented monitoring and logging solutions using Graylog to proactively identify and resolve issues.\n- Utilized Solr for efficient search functionalities and Couchbase for scalable NoSQL database solutions.\n- Embraced DevOps practices to streamline deployment processes and improve operational efficiency.\n- Support customer queries escalated from the Command Centre agents.\n- Fostered effective teamwork and systems thinking to deliver high-quality results.\n\n## Skills\n\n`tags:Agile, Object-Oriented Programming, C#, SQL, DevOps, Jenkins, MongoDB, Git, Windows, Visual Studio, HTML, CSS, JavaScript, Graylog, Git, BitBucket, Jira, SonarQube, Couchbase, HTML5 video players`\n\n`tags:Leadership, Communication, Problem Solving, Critical Thinking, Adaptability, Time Management, Team Work`\n\n`tags:Customer Service, Mentoring, Coaching, Conflict Resolution, Lean Principles, Waste Reduction`",
    "_meta": {
      "filePath": "2014-multichoice.md",
      "fileName": "2014-multichoice.md",
      "directory": ".",
      "extension": "md",
      "path": "2014-multichoice"
    },
    "date": new Date("2014-04-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/published-article-about-finding-opportunities-in-mistakes",
    "share": "/logos/typewriter.webp",
    "resume": {
      "name": "Finding Opportunities in the Mistakes We Make",
      "description": "A List Apart",
      "logo": "alistapart.png",
      "category": "Publication",
      "start": "2016-08-02",
      "summary": "An article about how I used the mistakes I made to find opportunities for growth and improvement.\n"
    },
    "content": "[Read](https://alistapart.com/article/finding-opportunities-in-the-mistakes-we-make/)\nmy frustrations and burn-out and how I started to use the mistakes\nI was making to find ways to improve my well-being\n\nCollaborating with Rose Weisburd, I wrote about burn out and falling behind in technology.\"\n\"I learned a lot in my career and shared how I found opportunities in the mistakes I made.",
    "_meta": {
      "filePath": "2016-publication-opportunities-in-mistakes.md",
      "fileName": "2016-publication-opportunities-in-mistakes.md",
      "directory": ".",
      "extension": "md",
      "path": "2016-publication-opportunities-in-mistakes"
    },
    "date": new Date("2016-08-02T00:00:00.000Z")
  },
  {
    "slug": "/resume/talk-at-jozi-jug-2016",
    "share": "/logos/microphone.webp",
    "resume": {
      "name": "Branding Your Identity",
      "description": "Java 9 and Women in tech Unconference with International guest Heather VanCura",
      "logo": "talk-generic.webp",
      "category": "Talk",
      "start": "2016-06-04",
      "summary": "A talk about how software developers can create a name for themselves by creating their own brand.\n"
    },
    "content": "[Jozi-JUG](https://www.meetup.com/Jozi-JUG/) is a Johannesburg, South Africa JVM User Group (Jozi-JUG) is a User Group.\n\nThis was my first talk.\nI shared how software developers can create a name for themselves by creating their own brand.",
    "_meta": {
      "filePath": "2016-talk-jozi-jug.md",
      "fileName": "2016-talk-jozi-jug.md",
      "directory": ".",
      "extension": "md",
      "path": "2016-talk-jozi-jug"
    },
    "date": new Date("2016-06-04T00:00:00.000Z")
  },
  {
    "slug": "/resume/talk-at-unconference-2016",
    "share": "/logos/microphone.webp",
    "resume": {
      "name": "Mindfulness",
      "description": "Unconference",
      "logo": "talk-generic.webp",
      "category": "Talk",
      "start": "2016-07-31",
      "summary": "A talk about mindfulness and how it can help software developers be more productive.\n"
    },
    "content": "The Unconference is an invite-only software development weekend retreat.\n\nI shared how practicing the art of mindfulness calmed me\nand made me more productive.",
    "_meta": {
      "filePath": "2016-talk-mindfulness.md",
      "fileName": "2016-talk-mindfulness.md",
      "directory": ".",
      "extension": "md",
      "path": "2016-talk-mindfulness"
    },
    "date": new Date("2016-07-31T00:00:00.000Z")
  },
  {
    "slug": "/resume/podcast-on-developer-on-fire",
    "share": "/logos/microphone.webp",
    "resume": {
      "name": "Episode 202 | Clarice Bouwer - Leaving Comfort Behind",
      "description": "ZA Dev Chat",
      "logo": "developer-on-fire.png",
      "category": "Podcast",
      "start": "2017-08-28",
      "summary": "An episode about collaboration, empathy, fear, and being an impostor.\n"
    },
    "content": "[Listen](https://developeronfire.com/podcast/episode-202-clarice-bouwer-leaving-comfort-behind)\nto the episode where I talk about collaboration, empathy, fear, and being an impostor.\n\nMy top 3 tips for delivering more value:\n\n- Reflect, inspect, and adapt\n- Be empathetic\n- Perfection is an illusion",
    "_meta": {
      "filePath": "2017-podcast-developer-on-fire.md",
      "fileName": "2017-podcast-developer-on-fire.md",
      "directory": ".",
      "extension": "md",
      "path": "2017-podcast-developer-on-fire"
    },
    "date": new Date("2017-08-28T00:00:00.000Z")
  },
  {
    "slug": "/resume/podcast-on-za-dev-chat",
    "share": "/logos/microphone.webp",
    "resume": {
      "name": "67 - The Imposter Within with Clarice Bouwer",
      "description": "ZA Dev Chat",
      "logo": "zadevchat.png",
      "category": "Podcast",
      "start": "2017-08-28",
      "summary": "An episode about imposter syndrome, what it is and how to overcome it.\n"
    },
    "content": "[Listen](https://zadevchat.io/67/) to the episode where I talk about imposter syndrome,\nwhat it is and how to overcome it. Join us as we learn about this and other issues around the often overlooked topics of mental well-being.\n\nInspired by Scott Hanselman's \"I'm a phony. Are you?\" post, I blogged about my own experiences with feeling like an imposter. This well written post landed her interviews on two other podcasts, ours, and the Reddit front page. I later presented at Rubyfuza 2017 and a recent Jozi.rb.\n\nThis post and other well researched posts focuses a lot on how important mental health & well-being is and shares a lot things we can do to look after ourselves.\n\n## Resources\n\n- [I'm a phony. Are you?](https://www.hanselman.com/blog/ImAPhonyAreYou.aspx)\n- [The Fear Behind the Scenes](/blog/the-fear-behind-the-scenes/)\n- [Developer on Fire 202](http://developeronfire.com/podcast/episode-202-clarice-bouwer-leaving-comfort-behind)\n- [Pauline Rose Clance Imposter Syndrome Test](http://paulineroseclance.com/pdf/IPscoringtest.pdf)\n- [Headspace](https://www.headspace.com/)\n- [Accidentally destroyed production database on first day of a job, and was told to leave, on top of this i was told by the CTO that they need to get legal involved, how screwed am i?](https://www.reddit.com/r/cscareerquestions/comments/6ez8ag/accidentally_destroyed_production_database_on/)",
    "_meta": {
      "filePath": "2017-podcast-za-dev-chat.md",
      "fileName": "2017-podcast-za-dev-chat.md",
      "directory": ".",
      "extension": "md",
      "path": "2017-podcast-za-dev-chat"
    },
    "date": new Date("2017-08-28T00:00:00.000Z")
  },
  {
    "slug": "/resume/talk-at-rubyfuza-2017",
    "share": "/logos/microphone.webp",
    "resume": {
      "name": "The Imposter Within",
      "description": "Rubyfuza 2017 Conference",
      "logo": "talk-ruby-fuza.webp",
      "category": "Talk",
      "start": "2017-02-03",
      "summary": "A talk about imposter syndrome, how it affects developers, and ways to overcome it.\n"
    },
    "content": "[Watch](https://www.youtube.com/watch?v=fkgAc0DY4s8) as I take the audience through my interpretation of\nimposter syndrome. You can also see the [highlights](https://twitter.com/i/moments/830378337516322816)\nor [read](/blog/rubyfuza-2017-conference/) about it.\n\n## Resources\n\n- [I'm a phony. Are you?](https://www.hanselman.com/blog/ImAPhonyAreYou.aspx)\n- [The Fear Behind the Scenes](/blog/the-fear-behind-the-scenes/)\n- [Developer on Fire 202](http://developeronfire.com/podcast/episode-202-clarice-bouwer-leaving-comfort-behind)\n- [Pauline Rose Clance Imposter Syndrome Test](http://paulineroseclance.com/pdf/IPscoringtest.pdf)\n- [Headspace](https://www.headspace.com/)\n- [Accidentally destroyed production database on first day of a job, and was told to leave, on top of this i was told by the CTO that they need to get legal involved, how screwed am i?](https://www.reddit.com/r/cscareerquestions/comments/6ez8ag/accidentally_destroyed_production_database_on/)",
    "_meta": {
      "filePath": "2017-talk-rubyfuza.md",
      "fileName": "2017-talk-rubyfuza.md",
      "directory": ".",
      "extension": "md",
      "path": "2017-talk-rubyfuza"
    },
    "date": new Date("2017-02-03T00:00:00.000Z")
  },
  {
    "slug": "/resume/cloudafrica",
    "share": "/logos/cloudafrica.png",
    "resume": {
      "logo": "cloudafrica.png",
      "category": "Career",
      "company": "CloudAfrica",
      "jobTitle": "Senior Software Engineer",
      "type": "Full-time",
      "arrangement": "Onsite",
      "location": "Rosebank, South Africa",
      "start": "2018-07-01",
      "end": "2019-07-31",
      "os": "linux",
      "tech": [
        "Web Development",
        "Functional Programming",
        "Clojure",
        "ClojureScript",
        "Datomic",
        "DevOps"
      ],
      "summary": "Radical career change from .NET to Clojure and Datomic in a DevOps powered virtualization environment. Develop software across the stack from web to infrastructure using Linux. Developed and maintained cloud-based solutions in Clojure and JavaScript, including a user-friendly interface for managing virtual machine firewall rules and NATs, which reduced manual support calls by 70% and boosted user efficiency. I also improved system performance, delivered full lifecycle projects, and implemented Grafana and Prometheus dashboards for real-time monitoring and proactive issue resolution."
    },
    "content": "CloudAfrica delivers high-performance, locally-hosted IaaS (cloud compute, storage, networking, backup) to businesses, developers and MSPs across South Africa.\n\n- Developed and maintained cloud-based software solutions using Clojure and JavaScript, contributing to a 70% reduction in manual support calls related to firewall and NAT management that integrates virtual machines and hosts.\n- Led the full software development lifecycle for key projects, ensuring timely and high-quality deliverables that met business requirements.\n- Designed and implemented a user-friendly front-end interface with backend functionality for managing virtual machine firewall rules and NATs, significantly improving user efficiency.\n- Enhanced system performance through iterative improvements and feedback, optimizing existing systems for greater efficiency and scalability.\n- Established comprehensive monitoring and reporting dashboards using Grafana and Prometheus, providing real-time insights into system performance and enabling proactive issue resolution.\n\n## Skills\n\n`tags: Functional Programming, Clojure, ClojureScript, Reframe, Datomic, DevOps, Prometheus, Grafana, Git, GitLab, Gerrit, Linux, IntelliJ, HTML, CSS, JavaScript`\n\n`tags: Communication, Problem Solving, Critical Thinking, Adaptability, Time Management, Team Work`",
    "_meta": {
      "filePath": "2018-cloudafrica.md",
      "fileName": "2018-cloudafrica.md",
      "directory": ".",
      "extension": "md",
      "path": "2018-cloudafrica"
    },
    "date": new Date("2018-07-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/published-article-about-chrome-devtools",
    "share": "/logos/typewriter.png",
    "resume": {
      "name": "Debugging with Chrome DevTools - Quick Front End Fixes",
      "description": "OfferZen",
      "logo": "offerzen.png",
      "category": "Publication",
      "start": "2018-07-22",
      "summary": "An article about familiarizing yourself with the Chrome DevTools to debug front-end issues quickly.\n"
    },
    "content": "[Read](https://www.offerzen.com/blog/debugging-with-chrome-devtools-quick-front-end-fixes) about familiarizing yourself with the Chrome DevTools.\n\nDebugging is an art form. Often, it feels like you need a series of serendipitous insights\nto fix a complicated bug. In reality, you need two things: technical knowledge\nto spot broader patterns and connections, and data on the bug itself to\nunderstand the problem.",
    "_meta": {
      "filePath": "2018-publication-chrome-devtools.md",
      "fileName": "2018-publication-chrome-devtools.md",
      "directory": ".",
      "extension": "md",
      "path": "2018-publication-chrome-devtools"
    },
    "date": new Date("2018-07-22T00:00:00.000Z")
  },
  {
    "slug": "/resume/testimonial-from-john-gillespie",
    "share": "/logos/speech-bubble.webp",
    "resume": {
      "name": "John Gillespie",
      "description": "We worked on the same team",
      "logo": "john-gillespie.jpeg",
      "category": "Testimonial",
      "jobTitle": "Certified Scrum Master and IT Professional",
      "start": "2018-03-20",
      "summary": "John commends me as an exceptional and collaborative team member, praising my commitment to exceeding expectations, technical competence, and eagerness to continually learn and grow."
    },
    "content": "I have had the distinct pleasure of working alongside Clarice for a number of years now.\nDuring this time I have come to know her as an upstanding individual, and an invaluable member of the team.\n\nClarice always strives to perform tasks to the best of her abilities, often going\nfar beyond what the original expectation was in an effort to permanently solve any\nproblems she might uncover. A competent developer, she is able to take initiative\nwhen the situation calls for it but also knows when to stand back and ask for\ndirection from other sources.\n\nClarice is extremely knowledgeable, and shows an eagerness to learn and grow in new fields\nas well as in her current field of expertise. I believe Clarice is an asset to any organization she works for.",
    "_meta": {
      "filePath": "2018-testimonial-john-gillespie.md",
      "fileName": "2018-testimonial-john-gillespie.md",
      "directory": ".",
      "extension": "md",
      "path": "2018-testimonial-john-gillespie"
    },
    "date": new Date("2018-03-20T00:00:00.000Z")
  },
  {
    "slug": "/resume/testimonial-from-maneesh-chiba",
    "share": "/logos/speech-bubble.webp",
    "resume": {
      "name": "Maneesh Chiba",
      "description": "We worked on the same team",
      "logo": "maneesh-chiba.jpeg",
      "category": "Testimonial",
      "jobTitle": "Team Lead at Higher Logic",
      "start": "2018-03-07",
      "summary": "Maneesh commends me for my exceptional knowledge and extensive experience in real-world implementations across various web, app, and software solutions, noting my commitment to refining skills, adherence to industry standards, and valuable contributions as an intelligent and questioning team player, expressing a strong desire to work with me again and highly recommending me to others."
    },
    "content": "I worked with Clarice during my time at DStv Digital Media\nacross two scrum teams. Clarice has an exceptional knowledge and experience\nwith real world implementations across various web,app and software solutions.\n\nShe is constantly refining her skills which results in code that is not only well\nwritten, but also compliant with industry standards as well the those of the project\nteam or company. She is unfliching in exploring outside of her defined realms and questions\nintelligently which makes her a huge asset on any team.\n\nIn addition to her excellent software development skills, Clarice is a real team player,\nhighly efficient and an all round pleasure to be around. I would personally jump at the\nopportunity to work with her again and highly recommend her to anyone.",
    "_meta": {
      "filePath": "2018-testimonial-maneesh-chiba.md",
      "fileName": "2018-testimonial-maneesh-chiba.md",
      "directory": ".",
      "extension": "md",
      "path": "2018-testimonial-maneesh-chiba"
    },
    "date": new Date("2018-03-07T00:00:00.000Z")
  },
  {
    "slug": "/resume/testimonial-from-suzaan-hepburn",
    "share": "/logos/speech-bubble.webp",
    "resume": {
      "name": "Suzaan Hepburn",
      "description": "We worked on the same team",
      "category": "Testimonial",
      "jobTitle": "Scrum Master at Momentum",
      "start": "2018-03-08",
      "summary": "Suzaan commends me as a versatile and thoughtful developer, highlighting my ability to lead and collaborate effectively, particularly during our work together on the DStv Now project, where I consistently sought innovative, customer-centric solutions, promoted agility in delivery, and prioritized quality, earning Suzaan's full recommendation."
    },
    "content": "Clarice is a thinking developer, she is able to take the lead and follow as needed,\nand this ability makes her a valuable asset in any team.\n\nI was the Scrum Master and we worked together on the DStv Now project. S\nhe was the developer always looking for the ways to integrate the best innovation and technical\nsolutions while ensuring it’s still customer centric. Clarice was always looking for ways\nof increasing agility in our delivery and ensuring quality is built into the product.\n\nAs a colleague Clarice is always striving to create mindfulness in her work and also in her relationships.\nI am happy with the work she did as part of the DStv Now project and give her my full recommendation.",
    "_meta": {
      "filePath": "2018-testimonial-suzaan-hepburn.md",
      "fileName": "2018-testimonial-suzaan-hepburn.md",
      "directory": ".",
      "extension": "md",
      "path": "2018-testimonial-suzaan-hepburn"
    },
    "date": new Date("2018-03-08T00:00:00.000Z")
  },
  {
    "slug": "/resume/cloudsure",
    "share": "/logos/cloudsure.png",
    "resume": {
      "logo": "cloudsure.png",
      "category": "Career",
      "company": "Cloudsure Limited",
      "jobTitle": "Software Engineering Team Lead and Director",
      "type": "Full-time",
      "arrangement": "Hybrid",
      "location": "Moka, Mauritius",
      "start": "2020-01-01",
      "end": "2025-11-14",
      "os": "macOS",
      "tech": [
        "Web Development",
        "Functional Programming",
        "Clojure",
        "ClojureScript",
        "TypeScript",
        "Next.js",
        "React",
        "Google Cloud Platform"
      ],
      "summary": "I co-led a distributed team of 15 engineers across two time zones while fostering collaboration, mentorship, and improved team morale. I architected and developed complex distributed systems on GCP, oversee daily code reviews, and maintain high standards in UX and DevX, ensuring both product and developer experiences are seamless. Beyond technical delivery, I drove business impact by onboarding new partners, contributing to major revenue growth, proactively resolving critical issues, and embedding systems thinking and post-mortems to prevent recurring challenges."
    },
    "content": "Cloudsure offers a white-labeled digital insurance platform to financial service providers. One of their biggest partners is Simply Financial Services. I started as a Senior Software Engineer at Simply Financial Services, moved to the partner company (Cloudsure Limited) based in Mauritius and was promoted to team lead on 1 November 2022.\n\n## Leadership & Team Management\n\n- Co-led a team of 15 engineers across two time zones, fostering a collaborative and high-performing environment.\n- Onboarded, mentored and guided engineers, improving their skills and the overall quality of code delivered.\n- Demonstrated strong leadership qualities through empathy and active listening, resulting in improved team communication, collaboration, and morale.\n- Managed the support team, shaving turnaround times down to a maximum of 3 days thus improving user satisfaction.\n\n## Software Development & Architecture\n\n- Navigated, developed, and architected complex distributed systems on GCP, encompassing over 10 repositories and 8 running applications.\n- Cross pollinated learnings through code reviews, documentation and communication.\n- Reviewed Merge Requests daily, ensuring code quality and adherence to programming guidelines.\n- Maintained a keen eye for detail in UX and DevX, contributing to improved user and developer experiences.\n\n## Business Impact & Problem Solving\n\n- Played a key role in onboarding new partners. Example, contributed to a 60% increase in company revenue in a 4 month project.\n- Contributed to the bigger picture through systems thinking by architecting and designing features that truly matter.\n- Proactively identified and resolved critical issues prior to product launches, mitigating potential risks.\n- Effectively managed high-pressure situations and resolve critical incidents, ensuring system stability.\n- Fixed issues at source, writing up and sharing post-mortems to prevent future challenges.\n\n## Skills\n\n`tags: Web Development, Clojure, ClojureScript, TypeScript, JavaScript, Next.js, React, Google Cloud Platform, Storybook, Polylith Architecture, Distributed Systems, Domain Driven Design, Functional Programming, DevOps, Emacs, Visual Studio Code, Cursor`\n\n`tags: Kubernetes, Cloud Functions, Cloud Scheduler, Pub/Sub, BigQuery, Datastore, SQL, React, Next.js, TypeScript, JavaScript, TailwindCSS, Git,GitLab, Ramda.js, Immutable.js, Node.js, npm, UX, DevX, Warp, K9s`\n\n`tags: Leadership, Team Management, Software Development, Architecture, Business Impact, Problem Solving, Lean Principles, Waste Reduction, Communication, Adaptability, Mentorship, Team Work`",
    "_meta": {
      "filePath": "2019-cloudsure.md",
      "fileName": "2019-cloudsure.md",
      "directory": ".",
      "extension": "md",
      "path": "2019-cloudsure"
    },
    "date": new Date("2020-01-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/gatsby-remark-interactive-gifs",
    "share": "/logos/gifs.webp",
    "resume": {
      "logo": "gifs.webp",
      "category": "Project",
      "company": "Personal Project",
      "jobTitle": "Gatsby Remark Interactive GIFs",
      "type": "8 GitHub Stars",
      "arrangement": "Pet Project",
      "location": "Blog",
      "start": "2020-04-24",
      "end": "2023-12-25",
      "tech": [
        "Web Development",
        "Gatsby",
        "Remark",
        "gif-frames"
      ],
      "summary": "Addressed the challenge of static GIFs in Gatsby websites by creating gatsby-remark-interactive-gifs. This plugin empowers developers to replace standard GIFs with interactive versions, giving users control over playback and improving the overall content experience. This resulted in more dynamic and engaging content for Gatsby sites."
    },
    "content": "Addressed the challenge of static GIFs in Gatsby websites by creating gatsby-remark-interactive-gifs. This plugin empowers developers to replace standard GIFs with interactive versions, giving users control over playback and improving the overall content experience. This resulted in more dynamic and engaging content for Gatsby sites.\n\n`tags: Web Development, Gatsby, Remark, gif-frames, npm`",
    "_meta": {
      "filePath": "2020-gifs.md",
      "fileName": "2020-gifs.md",
      "directory": ".",
      "extension": "md",
      "path": "2020-gifs"
    },
    "date": new Date("2020-04-24T00:00:00.000Z")
  },
  {
    "slug": "/resume/qualification-le-wagon-data-science",
    "share": "/logos/le-wagon.png",
    "resume": {
      "logo": "le-wagon.png",
      "category": "Education",
      "company": "Le Wagon",
      "jobTitle": "Data Science & Artificial Intelligence Bootcamp",
      "type": "Certification",
      "arrangement": "Hybrid",
      "location": "Mauritius",
      "start": "2023-06-01",
      "end": "2023-12-09",
      "tech": [
        "Data Science",
        "Python",
        "Artificial Intelligence",
        "Machine Learning",
        "Deep Learning",
        "SQL"
      ],
      "summary": "A hands-on and intensive part-time bootcamp that provided me with a solid foundation in data science and artificial intelligence. The program covered a wide range of topics, including data analysis, machine learning, deep learning, and natural language processing. Through practical projects and real-world applications, I gained valuable skills in programming (Python, SQL), data visualization, statistical analysis, and model deployment. This bootcamp has equipped me with the knowledge and confidence to pursue a career in data science and AI."
    },
    "content": "A hands-on and intensive part-time bootcamp that provided me with a solid foundation in data science and artificial intelligence. The program covered a wide range of topics, including data analysis, machine learning, deep learning, and natural language processing. Through practical projects and real-world applications, I gained valuable skills in programming (Python, SQL), data visualization, statistical analysis, and model deployment. This bootcamp has equipped me with the knowledge and confidence to pursue a career in data science and AI.\n\n## Certifications\n\nThis [certificate](https://kitt.lewagon.com/schoolings/31498/public_diploma?token=62b1206b60a5f462154c32c8f5061ea4c758a0e96a99db368dd9fe86cacb39cc) certifies that Clarice Bouwer has successfully completed the Data Science & Artificial Intelligence Bootcamp at Le Wagon on 09/12/2023.\n\n## Skills\n\n`tags: Data Science, Python, Artificial Intelligence, Machine Learning, Deep Learning, SQL, Data Analysis, Data Visualization, Statistical Analysis, Model Deployment, Google Cloud Platform, Git, GitHub, Jupyter Notebooks, Pandas, NumPy, Matplotlib, Seaborn, Scikit-learn, TensorFlow, Keras, Natural Language Processing`",
    "_meta": {
      "filePath": "2023-lewagon.md",
      "fileName": "2023-lewagon.md",
      "directory": ".",
      "extension": "md",
      "path": "2023-lewagon"
    },
    "date": new Date("2023-06-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/qualification-linkedin-architecture",
    "share": "/logos/linkedin-architecture.jpeg",
    "resume": {
      "logo": "linkedin-architecture.jpeg",
      "category": "Education",
      "company": "LinkedIn Learning",
      "jobTitle": "Software Architecture - Patterns for Developers",
      "type": "Certification",
      "arrangement": "Online",
      "location": "International",
      "start": "2023-01-30",
      "end": "2023-01-30",
      "tech": [
        "Software Architecture",
        "Design Patterns"
      ],
      "summary": "Apply the correct architecture to new systems and recognize patterns in existing systems. Covered the application landscape patterns such as microservices, application structure patterns like event sourcing, as well as UI patterns like model-view-controller (MVC) with pros and cons that help you determine which patterns to use."
    },
    "content": "- **Understanding Patterns**: The course explains various software architecture patterns, including application landscape patterns like microservices and application structure patterns like event sourcing.\n- **Application and Recognition**: It covers how to apply the correct architecture to new systems and recognize patterns in existing systems, helping you solve complex architectural problems effectively.\n\n## Certifications\n\nThis [certificate](https://www.linkedin.com/learning/certificates/7ad4568068400132307a0d72242937e25aa6273b79e4a9afede44a8aafc8431b) certifies that Clarice Bouwer has successfully completed the course on 30/01/2023.\n\n## Skills\n\n`tags: Artificial Intelligence, Machine Learning, Supervised Learning, Unsupervised Learning, Reinforcement Learning, Data Preparation, Feature Engineering, Model Training, Model Evaluation, Machine Learning Pipeline`",
    "_meta": {
      "filePath": "2023-linkedin-architecture.md",
      "fileName": "2023-linkedin-architecture.md",
      "directory": ".",
      "extension": "md",
      "path": "2023-linkedin-architecture"
    },
    "date": new Date("2023-01-30T00:00:00.000Z")
  },
  {
    "slug": "/resume/qualification-linkedin-machine-learning",
    "share": "/logos/linkedin-machine-learning.jpeg",
    "resume": {
      "logo": "linkedin-machine-learning.jpeg",
      "category": "Education",
      "company": "LinkedIn Learning",
      "jobTitle": "Artificial Intelligence Foundations - Machine Learning",
      "type": "Certification",
      "arrangement": "Online",
      "location": "International",
      "start": "2023-09-21",
      "end": "2023-09-21",
      "tech": [
        "Artificial Intelligence",
        "Machine Learning"
      ],
      "summary": "An introduction to machine learning, covering supervised, unsupervised, and reinforcement learning methods. It guides you through the machine learning lifecycle, from sourcing and preparing data to training and evaluating models, and building a machine learning pipeline."
    },
    "content": "Learned the basics of machine learning, including supervised, unsupervised, and reinforcement learning methods. Gained insights into the machine learning lifecycle from framing problems to identifying pre-built models and tools for training. Discovered how to obtain, visualize, and perform feature engineering on data to prepare it for machine learning. Explored various learning algorithms for classification and regression.\n\n- **Understanding Machine Learning**: Learn about the basics of machine learning, including how machines learn and the different types of machine learning methods (supervised, unsupervised, and reinforcement).\n- **Implementing Solutions**: Gain insights into the machine learning lifecycle, from framing problems to identifying pre-built models and understanding the tools used to train models.\n- **Data Preparation**: Understand how to obtain, visualize, and prepare data, including performing feature engineering.\n- **Model Training**: Explore various learning algorithms for classification and regression, and learn how to train custom machine learning models.\n- **Model Evaluation**: Learn to evaluate model performance using standard metrics, understand the confusion matrix, and determine feature importance while combating bias.\n- **Operationalizing Pipelines**: Discover how to structure and build a machine learning pipeline to streamline the process.\n\n## Certifications\n\nThis [certificate](https://www.linkedin.com/learning/certificates/fea05197f6dafd2c3b83447f0ee467a8391ff849a6a8164aa60357cd1b318e0a) certifies that Clarice Bouwer has successfully completed the course on 21/09/2023.\n\n## Skills\n\n`tags: Artificial Intelligence, Machine Learning, Supervised Learning, Unsupervised Learning, Reinforcement Learning, Data Preparation, Feature Engineering, Model Training, Model Evaluation, Machine Learning Pipeline`",
    "_meta": {
      "filePath": "2023-linkedin-machine-learning.md",
      "fileName": "2023-linkedin-machine-learning.md",
      "directory": ".",
      "extension": "md",
      "path": "2023-linkedin-machine-learning"
    },
    "date": new Date("2023-09-21T00:00:00.000Z")
  },
  {
    "slug": "/resume/qualification-udemy-lean-six-sigma",
    "share": "/logos/udemy-lss.webp",
    "resume": {
      "logo": "udemy-lss.webp",
      "category": "Education",
      "company": "Udemy",
      "jobTitle": "Lean Leadership Skills, Lean Culture & Lean Management",
      "type": "Certification",
      "arrangement": "Online",
      "location": "International",
      "start": "2024-12-01",
      "end": "2024-12-23",
      "tech": [
        "Lean Six Sigma",
        "Lean Principles",
        "Waste Reduction",
        "Leadership"
      ],
      "summary": "Learned to lead a change process in an organization, design a system of natural work and management teams who engage in continuous improvement, eliminate waste and engage team members in on-going process of continuous improvement (kaizen), and insights into lean culture (Toyota Production System)."
    },
    "content": "## Certification\n\nThis [certificate](https://www.udemy.com/certificate/UC-1a61f474-d430-4de8-bd83-777efbb1f530/) verifies that Clarice Bouwer successfully completed the course Lean Leadership Skills, Lean Culture & Lean Management on 12/23/2024 as taught by Lawrence M. Miller, Leadership Excellence, LLC on Udemy. The certificate indicates the entire course was completed as validated by the student. The course duration represents the total video hours of the course at time of most recent completion.\n\n## Concepts\n\n- It is about leadership - you will know how to lead a change process in your organization.\n- How to implement continuous improvement and lean culture (Toyota Production System) in your organization.\n- You will design a system of natural work and management teams who engage in continuous improvement.\n- The student completing this course will know the essential problem solving methods employed in continuous improvement.\n- You will be able to eliminate waste and engage your team members in an on-going process of continuous improvement (kaizen).\n\n## Skills\n\n`tags: Leadership, Company Culture, Change Management, Lean Six Sigma, Lean Principles, Waste Reduction, Communication, Problem Solving, Critical Thinking, Adaptability, Time Management`",
    "_meta": {
      "filePath": "2024-udemy-lean-six-sigma.md",
      "fileName": "2024-udemy-lean-six-sigma.md",
      "directory": ".",
      "extension": "md",
      "path": "2024-udemy-lean-six-sigma"
    },
    "date": new Date("2024-12-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/qualification-udemy-microservices",
    "share": "/logos/udemy-microservices.webp",
    "resume": {
      "logo": "udemy-microservices.webp",
      "category": "Education",
      "company": "Udemy",
      "jobTitle": "Design Microservices Architecture with Patterns & Principles",
      "type": "Certification",
      "arrangement": "Online",
      "location": "International",
      "start": "2024-12-01",
      "end": "2024-12-30",
      "tech": [
        "Domain Driven Design",
        "Event Driven Programming",
        "Microservices Architecture",
        "Distributed Systems",
        "CQRS",
        "DevOps"
      ],
      "summary": "Real-world experience about all architecture positions from monolithic to event-driven microservices architecture."
    },
    "content": "## Certification\n\nThis [certificate](https://www.udemy.com/certificate/UC-d6274ef0-2c8f-4c3d-a7d0-18edf0d4f6a0/) verifies that Clarice Bouwer successfully completed the course Design Microservices Architecture with Patterns & Principles on 12/30/2024 as taught by Mehmet Ozkaya on Udemy. The certificate indicates the entire course was completed as validated by the student. The course duration represents the total video hours of the course at time of most recent completion.\n\n## Concepts\n\nLearned how to design Microservices Architecture with using Design Patterns, Principles and the Best Practices with Iterate Design Architecture from Monolithic to Microservices.\n\n- Design Microservices Architecture with using Design Patterns, Principles and the Best Practices\n- Learn how to handle millions of request with designing system for High Availability, High Scalability, low latency, and resilience to network failures\n- Journey of Software Architecture Design from Monolithic to Serverless Microservices\n- Step by step evolving architecture from Monolithic to Event-driven Microservices Architecture\n- Design E-commerce App with Monolithic - Layered - Clean - Modular Monolithic - Microservices - Event-Driven Architecture and Serverless Microservices\n- Microservices Decomposition Strategies\n- Microservices Communications (Sync / Async Message-Based Communication, API Gateways))\n- Microservices Data Management (Databases / Query / Commands / Distributed Transactions)\n- Microservices Distributed Transaction Management\n- Microservices Distributed Caching\n- Microservices Deployments with Containers and Orchestrators\n- Microservices Resilience, Observability, Monitoring\n- Microservices Design Patterns and Best Practices\n- The Database-per-Service Pattern, Polyglot Persistence and The Shared Database Anti-Pattern\n- API Gateway Pattern, Backends for Frontends Pattern-BFF, Gateway Routing/Aggregation/Offloading Pattern\n- Service Aggregator Pattern, Service Registry/Discovery Pattern\n- Materialized View Pattern, Database Sharding Pattern, CAP Theorem\n- Fan-out Publish/Subscribe Messaging Pattern, Topic-Queue Chaining & Load Balancing Pattern\n- CQRS and Event Sourcing Patterns, Eventual Consistency Principle, CAP Theorem\n- SAGA Pattern — Choreography-based/Orchestration-based SAGA, Compensating Transaction Pattern\n- Transactional Outbox Pattern, Dual Write Problem\n- CDC — Change Data Capture with Outbox Pattern\n- Code Review for Existing Microservices Architecture Repository on GitHub\n- Event Hubs and Real-time Event Streaming in Event-Driven Microservices Architecture\n- Cache-Aside Pattern for Microservices Distributed Caching\n- Sidecar Pattern, Service Mesh Pattern\n- DevOps and CI/CD Pipelines for Microservices Deployments\n- Deployment Strategies for Microservices: Blue-green, Rolling and Canary deployments\n- Infrastructure as Code (IaC) and usage in Microservices Deployments\n- Microservices Resilience, Observability and Monitoring Patterns\n- Retry and Circuit Breaker Patterns\n- Bulkhead / Timeout / Cache / Fallback Patterns\n- Elastic Stack for Microservices Observability with Distributed Logging\n- Microservices Health Checks: Liveness, Readiness and Performance Checks\n- Serverless Microservices Architecture implementation on AWS\n- Hands-on Design Activities, Iterate Design Architecture from On-Premises to Cloud Serverless architectures\n- Refactoring System Design for handling million of requests\n- Prepare for Software Architecture Interviews\n- Prepare for System Design Architecture Interviews\n\n## Skills\n\n`tags: Domain Driven Design, Event Driven Programming, Microservices Architecture, Distributed Systems, CQRS, DevOps, Design Patterns, Software Architecture, High Availability, Scalability, Resilience, Monolithic, Serverless, API Gateway, Service Mesh, Observability, CI/CD`",
    "_meta": {
      "filePath": "2024-udemy-microservices.md",
      "fileName": "2024-udemy-microservices.md",
      "directory": ".",
      "extension": "md",
      "path": "2024-udemy-microservices"
    },
    "date": new Date("2024-12-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/qualification-lean-six-sigma",
    "share": "/logos/mf-treinamentos.png",
    "resume": {
      "logo": "mf-treinamentos.png",
      "category": "Education",
      "company": "MF Treinamentos",
      "jobTitle": "Lean Six Sigma Green Belt",
      "type": "Certification",
      "arrangement": "Online",
      "location": "International",
      "start": "2025-01-01",
      "end": "2025-01-31",
      "tech": [
        "Lean Six Sigma",
        "Lean Principles",
        "Waste Reduction",
        "Communication"
      ],
      "summary": "Earned my Lean Six Sigma Green Belt certification under the mentorship of Professor Marcelo Fernandes, gaining proficiency in DMAIC and advanced process improvement methodologies. This equipped me with data-driven problem-solving, project management, and continuous improvement skills, enabling me to streamline workflows, enhance efficiency, and deliver measurable business impact."
    },
    "content": "Exploring the principles of Lean Six Sigma, the Green Belt certification offered by MF OPEX, under the mentorship of Professor Marcelo Fernandes, represents a pivotal step forward in operational excellence training. Equipped with an extensive curriculum blending advanced theories with hands-on application, participants not only deepen their understanding of process optimization, advanced data analysis, and project leadership but also become adept at spearheading Lean Six Sigma projects. Professor Fernandes' esteemed guidance enriches the program with cutting-edge methodologies, empowering learners to drive substantial improvements within their organizations. Serving as a significant milestone in professional development, this certification not only qualifies individuals to lead larger-scale projects but also instills the confidence and expertise needed to enact transformative change across diverse industry landscapes.\n\nGained proficiency in Lean Six Sigma methodologies, including DMAIC, to drive process improvements and enhance efficiency. Equipped with tools and techniques for data-driven problem-solving, project management, and continuous improvement initiatives, resulting in streamlined workflows, identifying bottlenecks, implementing data-driven solutions, improved customer satisfaction, understanding the needs of my peers to drive innovation and achieving measurable results.\n\n## Certifications\n\n- [Green Belt Certification](https://certify.one/c/KvRNYN)\n- [Yellow Belt Certification](https://certify.one/c/Kz7kv9)\n- [White Belt Certification](https://certify.one/c/M3x8BX)\n\n## Skills\n\n`tags: Lean Six Sigma, Lean Principles, Waste Reduction, Communication, Problem Solving, Critical Thinking, Adaptability, Time Management`",
    "_meta": {
      "filePath": "2025-mf-treinamentos.md",
      "fileName": "2025-mf-treinamentos.md",
      "directory": ".",
      "extension": "md",
      "path": "2025-mf-treinamentos"
    },
    "date": new Date("2025-01-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/openskill-pro",
    "share": "/logos/openskill-pro.webp",
    "resume": {
      "logo": "openskill-pro.webp",
      "category": "Project",
      "company": "Personal Project",
      "jobTitle": "OpenSkill Pro",
      "type": "R&D",
      "arrangement": "Pet Project",
      "location": "Product",
      "start": "2025-07-01",
      "tech": [
        "Web Development",
        "HTML",
        "CSS",
        "TypeScript",
        "Next.js",
        "Tailwind CSS",
        "Firebase",
        "Netlify"
      ],
      "summary": "Architected and developed OpenSkill Pro, a resume optimization platform leveraging AI to bridge the gap between candidate profiles and employer expectations. Key features include resume parsing, marketability scoring, personalized feedback, and AI-assisted persona tailoring to match specific job descriptions and company profiles."
    },
    "content": "Architected and developed OpenSkill Pro, a resume optimization platform leveraging AI to bridge the gap between candidate profiles and employer expectations. Key features include resume parsing, marketability scoring, personalized feedback, and AI-assisted persona tailoring to match specific job descriptions and company profiles.\n\n`tags: Next.js, Shadcn, TailwindCSS, TypeScript, tRPC, Netlify, Firebase Authentication, Firebase Firestore, Firebase Storage, Google Cloud Platform, npm, Gemini-Flash, Prompt Engineering`",
    "_meta": {
      "filePath": "2025-open-skill.md",
      "fileName": "2025-open-skill.md",
      "directory": ".",
      "extension": "md",
      "path": "2025-open-skill"
    },
    "date": new Date("2025-07-01T00:00:00.000Z")
  },
  {
    "slug": "/resume/rsvp-birthday",
    "share": "/logos/rsvp.webp",
    "resume": {
      "logo": "rsvp.webp",
      "category": "Project",
      "company": "Personal Project",
      "jobTitle": "Birthday Party Event Registration",
      "type": "Tight-knit Guest List",
      "arrangement": "Pet Project",
      "location": "Blog",
      "start": "2025-05-01",
      "end": "2025-07-01",
      "tech": [
        "Web Development",
        "HTML",
        "CSS",
        "TypeScript",
        "Next.js",
        "Tailwind CSS",
        "Firebase",
        "Netlify"
      ],
      "summary": "I designed and built a centralized event registration platform with Next.js, integrating Firebase for secure authentication and data management. By implementing a user-friendly Shadcn and TailwindCSS interface, I streamlined RSVP handling, reduced errors, and delivered a seamless guest experience."
    },
    "content": "I designed and built a centralized event registration platform with Next.js, integrating Firebase for secure authentication and data management. By implementing a user-friendly Shadcn and TailwindCSS interface, I streamlined RSVP handling, reduced errors, and delivered a seamless guest experience.\n\nStreamlined guest management by designing and building a centralized registration system with Next.js, reducing manual RSVP tracking and errors.\n\nEnhanced user experience through a modern, intuitive interface built with Shadcn UI and TailwindCSS, increasing guest engagement and response rates.\n\nEnsured secure and reliable data handling by integrating Firebase authentication and data management, reinforcing trust and safeguarding attendee information.\n\n`tags: Web Development, Next.js, Shadcn, TailwindCSS, TypeScript, Netlify, Firebase Authentication, Firebase Firestore, npm`",
    "_meta": {
      "filePath": "2025-rsvp.md",
      "fileName": "2025-rsvp.md",
      "directory": ".",
      "extension": "md",
      "path": "2025-rsvp"
    },
    "date": new Date("2025-05-01T00:00:00.000Z")
  }
]